import { DictionaryWaterFlowAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryWaterFlows() {
  return useAutocompleteSource<DictionaryWaterFlowAutocomplete>({
    url: EvidenceAPI.DICTIONARY_WATER_FLOWS + '/autocomplete',
  });
}
